<template>
  <v-select
    v-model="selected"
    :label="label"
    :items="items"
    hide-selected
    hide-details
    :clearable="clearable"
    menu-props="offsetY"
    :outline="outline ? outline : true"
    :height="heightField ? heightField : 44"
    @change="changeReference"
  />
</template>
<script>
export default {
  props: ["label", "value", "clearable", "outline", "heightField"],
  data() {
    return {
      items: [
        { text: "Нет", value: false },
        { text: "Да", value: true },
      ],
      selected: this.value,
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.selected = newValue === null ? null : newValue.booleanValue;
      },
      immediate: true,
    },
  },
  methods: {
    changeReference() {
      return this.$emit(
        "input",
        this.selected === null || this.selected === undefined
          ? null
          : {
            title: this.items.find((i) => i.value === this.selected).text,
            booleanValue: this.selected,
          },
      );
    },
  },
};
</script>
